import {
    organizationApi,
    Organization,
    OrganizationId,
    OrganizationUser,
} from "@/api/organizations";
import { TeamId } from "@/api/teams";
import { useQueryCache } from "@pinia/colada";
import { ensureQueryData } from "./utils";

export const ORG_KEYS = {
    root: ["organizations"] as const,
    list: () => [...ORG_KEYS.root, "list"] as const,
    teams: (id: OrganizationId) => [...ORG_KEYS.root, "teams", id] as const,
    users: (id: OrganizationId) => [...ORG_KEYS.root, "orgUsers", id] as const,
};

const LOOKUP_STALE_MS = 5 * 60_000;

export const organizationsQueryOptions = {
    key: ORG_KEYS.list(),
    query: () => organizationApi.getOrganizations(),
    staleTime: LOOKUP_STALE_MS,
};

export function organizationTeamsQueryOptions(id: OrganizationId) {
    return {
        key: ORG_KEYS.teams(id),
        query: () => organizationApi.getTeams(id),
        staleTime: LOOKUP_STALE_MS,
    };
}

export function organizationUsersQueryOptions(id: OrganizationId) {
    return {
        key: ORG_KEYS.users(id),
        query: () => organizationApi.getUsers(id),
        staleTime: LOOKUP_STALE_MS,
    };
}

export function readCachedOrganizations(): Organization[] | undefined {
    return useQueryCache().getQueryData<Organization[]>(ORG_KEYS.list());
}

export function readCachedOrganizationTeams(id: OrganizationId): TeamId[] | undefined {
    return useQueryCache().getQueryData<TeamId[]>(ORG_KEYS.teams(id));
}

export function readCachedOrganizationUsers(id: OrganizationId): OrganizationUser[] | undefined {
    return useQueryCache().getQueryData<OrganizationUser[]>(ORG_KEYS.users(id));
}

export async function ensureOrganizations(force = false): Promise<Organization[] | undefined> {
    return await ensureQueryData<Organization[]>(organizationsQueryOptions, force);
}
